const imageHostPath = 'https://staticcn.coros.com/images';

// 加载图片
function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageHostPath + url;
    image.setAttribute('crossOrigin', 'Anonymous');
    image.onerror = function (err) {
      reject(err);
    };
    image.onload = function (e) {
      if (!e.target) {
        reject(new Error('error'));
      }
      resolve(image);
    };
  });
}

export function mixPic(muscleList, type = 'front') {
  const promiseList = [
    // 生成肌肉组合图
    getMuscleCanvas(muscleList, type),

    // 生成线条组合图
    getLineCanvas(muscleList, type)
  ];

  return Promise.all(promiseList)
    .then((canvasList) => {
      const width = canvasList[0].width;
      const height = canvasList[0].height;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      // 清空画布默认内容
      ctx.clearRect(0, 0, width, height);

      canvasList.forEach((item) => {
        if (!item) {
          return;
        }
        ctx.drawImage(item, 0, 0);
      });

      return Promise.resolve(canvas.toDataURL('image/png', 1));
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

// 生成肌肉组合图
export function getMuscleCanvas(muscles, type = 'front') {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const imagePromiseList = [];
  muscles.forEach((item) => {
    if (item[`${type}Pic`]) {
      imagePromiseList.push(loadImage(item[`${type}Pic`]));
    }
  });

  return Promise.all(imagePromiseList)
    .then((images) => {
      const width = images[0].width;
      const height = images[0].height;

      canvas.width = width;
      canvas.height = height;
      // 清空画布默认内容
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const canvasData = ctx.getImageData(0, 0, width, height);

      // 创建新的画布获取图片像素数据
      const imageCanvas = document.createElement('canvas');
      const imageCtx = imageCanvas.getContext('2d');
      imageCanvas.width = width;
      imageCanvas.height = height;

      for (let n = 0, length = images.length; n < length; n++) {
        const item = images[n];
        imageCtx.clearRect(0, 0, width, height);
        // 写入图片
        imageCtx.drawImage(item, 0, 0, width, height);
        // 像素操作
        const imgData = imageCtx.getImageData(0, 0, width, height);
        // 对应等级寻找颜色定义
        const rgb = muscles[n].levelColorInfo.split(',');
        for (let i = 0; i < imgData.data.length; i += 4) {
          if (imgData.data[i + 3] !== 0) {
            // 不是透明的，就改变颜色
            canvasData.data[i] = Number(rgb[0]);
            canvasData.data[i + 1] = Number(rgb[1]);
            canvasData.data[i + 2] = Number(rgb[2]);
            canvasData.data[i + 3] = Number(imgData.data[i + 3]);
          }
        }
      }

      ctx.putImageData(canvasData, 0, 0);
      return Promise.resolve(canvas);
    })
    .catch((err) => {
      console.error(err);
      return Promise.reject(err);
    });
}

// 生成线条组合图
export function getLineCanvas(muscles, type = 'front') {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const imagePromiseList = [];
  muscles.forEach((item) => {
    if (item[`${type}LinePic`]) {
      imagePromiseList.push(loadImage(item[`${type}LinePic`]));
    }
  });

  if (imagePromiseList.length === 0) {
    return Promise.resolve(null);
  }

  return Promise.all(imagePromiseList)
    .then((images) => {
      const width = images[0].width;
      const height = images[0].height;

      canvas.width = width;
      canvas.height = height;
      // 清空画布默认内容
      ctx.clearRect(0, 0, width, height);

      for (let n = 0, length = images.length; n < length; n++) {
        const item = images[n];
        // 写入图片
        ctx.drawImage(item, 0, 0, width, height);
      }

      return Promise.resolve(canvas);
    })
    .catch((err) => {
      console.error(err);
      return Promise.reject(err);
    });
}

// 获取肌肉等级对应的颜色
export function findMuscleColor(level) {
  // const theme = this.$store.state.theme === 'theme-dark'
  const theme = 'theme-dark';
  const lv = Number(level);
  switch (lv) {
    case 0:
      return theme ? '51,56,69' : '255,218,221';
    case 1:
      return theme ? '67,46,61' : '255,201,206';
    case 2:
      return theme ? '68,40,60' : '255,184,190';
    case 3:
      return theme ? '87,44,61' : '255,167,175';
    case 4:
      return theme ? '123,56,72' : '255,150,159';
    case 5:
      return theme ? '159,67,84' : '255,133,144';
    case 6:
      return theme ? '194,79,95' : '255,116,128';
    case 7:
      return theme ? '219,87,101' : '255,99,113';
    case 8:
      return theme ? '255,99,113' : '255,82,98';
  }
}
